<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-row justify="center">
                    <v-flex xs6 sm4 md2 lg1 mb-6>
                        <router-link to="/youtv/"><v-img :transition="false" src="/img/youtv_logo.png"></v-img></router-link>
                    </v-flex>
                    <!-- v-card dark class="elevation-0 ma-1 tile" color="transparent" tile>
                        <v-card-title>
                            <span class="display-1 youtv--text">youtv</span>
                        </v-card-title>
                    </v-card -->
                </v-row>
                <v-row v-for="item in servicesItems" :key="item.id" justify="center" class="youtv--list">
                    <v-card dark  class="elevation-0 ma-1 youtvback" width="300" tile >
                        <v-card-title>
                            <span class="headline">{{item.name}}</span>
                            <span class="body-2 ma-4 d-flex d-md-none">{{item.description}}</span>
                        </v-card-title>
                    </v-card>
                    <v-card dark class="elevation-0 ma-1 youtvback d-none d-md-flex" width="200" tile :color="item.color">
                        <v-card-text>
                            <span class="body-2">{{item.description}}</span>
                        </v-card-text>
                    </v-card>
                    <v-card dark class="elevation-0 ma-1 youtvback d-none d-sm-flex" width="200" tile :color="item.color">
                        <v-card-text>
                            <span class="subtitle-1" v-html="item.info"></span>
                        </v-card-text>
                    </v-card>
                    <v-card dark class="elevation-0 ma-1 youtvback d-xs-block" width="200" tile :color="item.color">
                        <v-card-title>
                            <v-spacer></v-spacer>
                            {{item.price}} грн.
                        </v-card-title>
                        <!-- v-card-text>
                            <p class="caption text-right">{{item.name}}</p>
                        </v-card-text -->
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red" @click="$router.push(`/youtv/buy/${item.id}`)">Купити</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-row justify="center">
                    <v-card dark class="text-center elevation-0 ma-1 tile" color="black" tile>
                        <v-card-title>
                            <span class="youtv--text">Попередні продажі</span>
                        </v-card-title>
                        <v-card-text>
                            <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
                                <validation-provider v-slot="{ errors, valid }" rules="required|tel">
                                    <v-text-field :success="valid" persistent-hint hint="Введіть номер телефону покупця, на який здійснювався продаж" prepend-icon="mdi-phone" name="phone" label="Телефон покупця" placeholder="+38(000) 000 - 0000" v-mask="maskTel" v-model="phone"></v-text-field>
                                </validation-provider>
                                <v-btn color="red" class="mt-6" text @click="passes(submitForm)" :disabled="invalid || !validated">Показати</v-btn>
                            </ValidationObserver>
                        </v-card-text>
                    </v-card>
                </v-row>
            </v-col>
        </v-row>
        <YoutvReminderDialog :opened.sync="dialog" />
    </v-container>
    </template>
    
    <script>
    import {
        mask
    } from 'vue-the-mask'
    
    import {
        ValidationObserver,
        ValidationProvider
    } from "vee-validate"
    
    import YoutvReminderDialog from '../components/YoutvReminderDialog.vue'
    
    import {
        mapActions
    } from 'vuex'
    
    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            YoutvReminderDialog
        },
        directives: {
            mask
        },
        data() {
            return {
                maskTel: '+38(###) ###-####',
                phone: null,
                dialog: false
            }
        },
        methods: {
            ...mapActions(['getYoutvCodesByPhone', 'remindeYoutvCode']),
            submitForm() {
                this.getYoutvCodesByPhone({phone: this.phone})
                this.dialog = true
            }
        },
        created() {
    
        },
        computed: {
            servicesItems() {
                return this.$store.state.youtv.youtvList
            },
        }
    }
    </script>
    
    <style>
    @media (max-width: 740px) {
    .youtv--list > div:nth-child(3) {
        display: none !important;
    }
    .youtv--list > div:nth-child(1) {
        width: 60% !important;
    }
    .youtv--list > div:nth-child(4) {
        width: 35% !important;
    }
    }
    </style>
    